import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';

export class Group {
  name: string;
  children: Group[];
  path: string;
  expandable?: boolean;
  level?: number;
}

@Component({
  selector: 'app-group-path-tree',
  templateUrl: './group-path-tree.component.html',
  styleUrls: ['./group-path-tree.component.scss'],
  standalone: false
})
export class GroupPathTreeComponent implements AfterViewInit {
  @Input() set groupPaths(value: string[]) {
    if (value) {
      this.buildTree(value);
      this.refreshTree();
    }
  }
  @Input() expanded: boolean = true;

  @Output() selectedPathChange: EventEmitter<string> = new EventEmitter<string>();

  private readonly transformer = (node: Group, level: number) => {
    node.expandable = !!node.children && node.children.length > 0;
    node.level = level;
    return node;
  };
  treeControl = new FlatTreeControl<Group>(
    node => node.level,
    node => node.expandable
  );
  treeFlattener = new MatTreeFlattener(
    this.transformer,
    node => node.level,
    node => node.expandable,
    node => node.children
  );
  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  selectedFolderName: string;
  currentLevel: number = 0;

  groupTree: Group[];

  afterViewInit: boolean = false;

  ngAfterViewInit() {
    this.afterViewInit = true;
    // Set to next tick to avoid Angular's ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => { this.refreshTree() }, 0);
  }

  hasChild = (_: number, node: Group) => node?.expandable === true;

  buildTree(groupPaths: string[]) {
    groupPaths.sort((a, b) => a.localeCompare(b));

    const newGroupTree = [];
    for (const path of groupPaths) {
      if (path !== undefined) {
        const paths = path.split('/');
        const rootGroup = paths.shift();

        let curGroup: Group;
        const existingTopGroup = newGroupTree.find(g => g.name === rootGroup);
        if (existingTopGroup) {
          curGroup = existingTopGroup;
        } else {
          curGroup = { name: rootGroup, children: [], path: rootGroup };
          newGroupTree.push(curGroup);
        }

        for (const childGroup of paths) {
          const existingChildGroup = curGroup.children.find(g => g.name === childGroup);
          if (existingChildGroup) {
            curGroup = existingChildGroup;
          } else {
            const deeperGroup: Group = { name: childGroup, children: [], path: `${curGroup.path}/${childGroup}` };
            curGroup.children.push(deeperGroup);
            curGroup = deeperGroup;
          }
        }
      }
    }
    this.groupTree = newGroupTree;
    this.dataSource.data = this.groupTree;
  }

  refreshTree() {
    if (this.afterViewInit && this.treeControl?.dataNodes?.length > 0) {
      this.treeControl.expandAll();
      const firstNode = this.treeControl?.dataNodes[0];
      this.toggleNodeSelected(firstNode);
    }
  }

  toggleNodeSelected(node: Group) {
    this.selectedFolderName = node.name;
    this.currentLevel = node.level;
    this.selectedPathChange.emit(node.path);
  }
}
